import { useState } from "preact/hooks";
import { strings } from "../i18n/strings.es-AR.js";
import { phase, conversation, agentName } from "../state/store.js";
import { getEntry, startNew, closeSession } from "../hooks/useConversation.js";
import { ConfirmDialog } from "./ConfirmDialog.jsx";
import { Header } from "./Header.jsx";
import { OfflineBanner } from "./OfflineBanner.jsx";
import { NotificationsBanner } from "./NotificationsBanner.jsx";
import { InstallBanner } from "./InstallBanner.jsx";
import { MessageList } from "./MessageList.jsx";
import { Composer } from "./Composer.jsx";

export function ChatScreen() {
  const [confirmingClose, setConfirmingClose] = useState(false);
  const mode = getEntry().mode;
  const currentPhase = phase.value;

  // La app ocupa TODO el viewport, en mobile y en desktop. Cada pieza pinta su
  // fondo a todo el ancho y centra su contenido en `chat-col` (definida en
  // styles.css): ese es el único lugar donde vive el ancho máximo.
  return (
    <div class="flex h-full w-full flex-col">
      {mode !== "miflux" && <Header onRequestCloseSession={() => setConfirmingClose(true)} />}
      <OfflineBanner />

      {conversation.value.handoffActive && (
        <div class="bg-flux-cyan px-4 py-2 text-xs font-medium text-flux-navy">
          <div class="chat-col text-center">
            {strings.agentBanner(agentName.value)} · {strings.handoffActive}
          </div>
        </div>
      )}
      <NotificationsBanner />
      <InstallBanner />

      {currentPhase === "error" ? (
        <div class="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center">
          <p class="text-sm text-white/80">{strings.errorStart}</p>
          <button
            type="button"
            class="rounded-full bg-flux-primary px-5 py-2 text-sm font-medium text-white"
            onClick={() => startNew()}
          >
            {strings.retry}
          </button>
        </div>
      ) : (
        <>
          <MessageList />
          <Composer />
        </>
      )}

      {/* Cerrar sesión borra el hilo del dispositivo y no tiene deshacer. */}
      {confirmingClose && (
        <ConfirmDialog
          title={strings.closeSessionConfirmTitle}
          body={strings.closeSessionConfirmBody}
          confirmLabel={strings.closeSessionConfirmAction}
          cancelLabel={strings.cancel}
          onCancel={() => setConfirmingClose(false)}
          onConfirm={() => { setConfirmingClose(false); closeSession(); }}
        />
      )}
    </div>
  );
}
